export const ThemeSettingsConstants = {
    SeasonalBackgroundImageSource: '/sign-in-bg-spring-2020.jpg'
};
